import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { ShieldOff } from 'lucide-react';

export default function ContaDesativada() {
  const { t } = useTranslation();
  const { signOut } = useAuthContext();
  const navigate = useNavigate();

  const handleSair = async () => {
    await signOut();
    navigate('/auth', { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="text-center max-w-md">
        <ShieldOff className="h-10 w-10 mx-auto mb-4 text-muted-foreground" />
        <h1 className="text-2xl font-bold text-foreground mb-2">
          {t('deactivatedAccount.title')}
        </h1>
        <p className="text-muted-foreground mb-6">{t('deactivatedAccount.description')}</p>
        <Button onClick={handleSair}>{t('common.logout', 'Sair')}</Button>
      </div>
    </div>
  );
}
